import { ContactTypeString, PermissionsService, ContactType } from '@tgx/shared/enums';

export const ContactTypeForm = {
  [ContactTypeString.API_IMPLEMENTATION]: ContactType.API_IMPLEMENTATION,
  [ContactTypeString.TECH_SUPPORT]: ContactType.TECH_SUPPORT,
  [ContactTypeString.BILLING]: ContactType.BILLING,
  [ContactTypeString.ACTIVATION]: ContactType.ACTIVATION,
} as const;

export const MappedMemberRole = {
  [PermissionsService.HOTELX]: 'newRoleInHotelX',
  [PermissionsService.ENTITIES]: 'newRoleInEntities',
  [PermissionsService.BILLING]: 'newRoleInBilling',
  [PermissionsService.USER]: 'newRoleInUser',
  [PermissionsService.FASTX]: 'newRoleInFastX',
} as const;
